import * as React from 'react';
import { Button } from '@cian/ui-kit';

import * as styles from './LocationModalFooter.css';
import { TLocationModalStep } from '../../../../types/locationModal';

interface ILocationModalFooterProps {
  step: TLocationModalStep;
  onBackClick(): void;
  onSubmit(): void;
}

export const LocationModalFooter: React.FC<ILocationModalFooterProps> = ({ step, onBackClick, onSubmit }) => {
  return (
    <div className={styles['container']}>
      {step === 'cities' && (
        <div className={styles['cities-step']}>
          <Button onClick={onBackClick} size="XS" theme="fill_secondary" type="button">
            Назад к регионам
          </Button>
        </div>
      )}
      <Button onClick={onSubmit} size="XS" type="submit">
        Применить
      </Button>
    </div>
  );
};
